(function() {
    var PLAYER_CSS_URL = '/o/ow-video-videojs/js/player.css';
    var PLAYER_CSS_LINK_ID = 'ow-video-videojs-player-css';

    var playerModulePromise = null;

    function loadPlayerCss() {
        if (document.getElementById(PLAYER_CSS_LINK_ID)) {
            return;
        }

        var link = document.createElement('link');
        link.id = PLAYER_CSS_LINK_ID;
        link.rel = 'stylesheet';
        link.href = PLAYER_CSS_URL;

        document.head.appendChild(link);
    }

    function loadPlayerModule() {
        if (!playerModulePromise) {
            loadPlayerCss();

            playerModulePromise = import('/o/ow-video-videojs/js/player.js');
        }

        return playerModulePromise;
    }

    function generateId() {
        return 'owVideo' + Date.now().toString(36) +
            Math.floor(Math.random() * 1e9).toString(36);
    }

    function insertOWVideoPlayers() {
        var videoNodes = document.querySelectorAll(
            '.ow-video.video-container');

        if (!videoNodes) {
            return;
        }

        [].slice.call(videoNodes).forEach(function(videoNode) {

            // In CKEditor we want a fake element, not an actual player.
            if (videoNode.closest('.cke_editable')) {
                return;
            }

            var mediaDiv = videoNode.querySelector('.ow-video-no-id');

            if (!mediaDiv) {
                return;
            }

            var mediaDivId = generateId();
            mediaDiv.setAttribute('id', mediaDivId);

            // Prevent this script and legacy script-per-instance from
            // both operating and hence creating two player instances.
            mediaDiv.classList.remove('ow-video-no-id');

            var props = {
                hasBorder: videoNode.getAttribute('data-has-border'),
                owVideoId: videoNode.getAttribute('data-ow-video-id'),
                width: videoNode.getAttribute('data-width')
            };

            loadPlayerModule().then(function(playerModule) {
                playerModule.mount(mediaDiv, props);
            }).catch(function(error) {
                console.error(error);
            });
        });
    }

    // The call below works for article display and edit pages.
    insertOWVideoPlayers();

    // Special case of the translation portlet, where the JSP page is
    // loaded and then the Translate React app. renders itself over the
    // top of it, undoing our work.

    var translateCmptMountNode = document.querySelector(
        '#portlet_' + TranslationPortletKey + ' .translation');

    if (translateCmptMountNode) {
        translateCmptMountNode.addEventListener(
            'DOMNodeInserted', insertOWVideoPlayers);
    }
})();
